import { isTimeFormatValid } from "./time"

export const isOverlapping = (time, startTime, endTime) => {

  const getTimeInMinutes = (time) => {
    let splitedTime = time.split(":")
    let hours = parseInt(splitedTime[0], 10)
    let minutes = parseInt(splitedTime[1], 10)
    return hours * 60 + minutes
  }

  if (!(isTimeFormatValid(startTime) && isTimeFormatValid(endTime) && isTimeFormatValid(time))) {
    // it cannot be overlapping if value compare against is not even valid
    return false
  }

  let endTimeInMinutes = getTimeInMinutes(endTime)
  let startTimeInMinutes = getTimeInMinutes(startTime)
  let timeInMinutes = getTimeInMinutes(time)

  if (endTimeInMinutes >= startTimeInMinutes) {
    // handle sequential range, e.g. 02:00 - 20:00 this means 2am until 8pm
    // e.g. 03:00 is inside the range and 21:00 is not
    return (timeInMinutes >= startTimeInMinutes) && (timeInMinutes <= endTimeInMinutes)
  } else {
    // handles across to next day the range e.g. 20:00 - 02:00 this means 8pm until 2am the next day
    // e.g. 21:00 is inside the range and 03:00 is not
    // ps: the logic is the 'inverse' of the sequential range e.g. flip the start and end and then reverse the result
    return !((timeInMinutes > endTimeInMinutes) && (timeInMinutes < startTimeInMinutes))
  }
}

export const isTimeValid = (poolTimes, value, index, isClosed) => {
  // if the day is closed, hours can be overlapping or even start and end time equals (to be backward compatible)
  if(isClosed === true)
    return true

  return poolTimes.every((poolTime, i) => {
    if (i === index) {
      // merely check if start and end times are the same
      // not checking if startTime must be less than endTime as pool hours can go into next day so its also valid
      return poolTime.startTime !== poolTime.endTime
    } else {
      return !isOverlapping(value, poolTime.startTime, poolTime.endTime)
    }
  })
}

export const isPoolTimesValid = (poolTimes, closed) => {

  // expect at least one hour even for closed day (validation to be backward compatible with restaurant hours)
  if(closed === true && poolTimes.length >= 1)
    return true

  return poolTimes.every((poolTime, i) => [
    isTimeFormatValid(poolTime.startTime),
    isTimeFormatValid(poolTime.endTime),
    isTimeValid(poolTimes, poolTime.startTime, i, closed),
    isTimeValid(poolTimes, poolTime.endTime, i, closed)
  ].every(Boolean))
}



// WEBPACK FOOTER //
// ./src/helpers/poolTime.js